import { TooltipWrapper } from 'components/TooltipWrapper';
import type { WorkOrderPriceItem } from 'gql/graphql';
import { WorkOrderPriceTypeEnum } from 'gql/graphql';
import { CodeCell } from 'pages/Project/Common/CodeCell';
import { Badge } from 'uikit';

import type { ICellRendererParams } from 'ag-grid-community';

import Styles from './cellRenderer.module.css';

export const StatusCellRenderer = (props: ICellRendererParams<WorkOrderPriceItem>) => {
    const { data } = props;

    if (!data || data?.type === WorkOrderPriceTypeEnum.RootObject) {
        return null;
    }

    return (
        <div className={Styles.groupContainer}>
            {data?.hasLimitSpan ? (
                <TooltipWrapper message="Добавлено за счёт распределения лимитов" isInteractive={false}>
                    <Badge size="s" status="system" label="Л" />
                </TooltipWrapper>
            ) : (
                <div />
            )}
            {data?.status ? <CodeCell status={data.status} /> : <div />}
        </div>
    );
};

StatusCellRenderer.displayName = 'StatusCellRenderer';
